import { useEffect, useState } from "react";
import { Alert, Button, Dropdown, OverlayTrigger, Stack, Tooltip } from "react-bootstrap";
import ProductCategory from "./ProductCategory";
import styles from './style.module.css';
import { updatePropertyInList, updatePropertyInListNoFixed } from "./utils";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

export default function TypeProductCategory({ jwt, type, products, fileOptions, onUpdate, categories, onSum, onWeight, discountProducts, additionCoefficient }) {

  const [currentCategory] = useState(categories.filter(f => f.categoryId == type.id));
  const [amounts, setAmounts] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [extraSlots, setExtraSlots] = useState({});

  const getSumAfterDiscount = (sum, productId) => {
    if (!productId) return sum;
    const finds = +(discountProducts.filter(f => f.products.findIndex(findOne => findOne.id == productId) != -1 && f.math == 2)).reduce((a, b) => a + +b.value, 0);
    return sum - sum * (finds / 100);
  };

  useEffect(() => {
    let sum = 0;
    for (let i = 0; i < amounts.length; i++) {
      const element = amounts[i];
      sum += element.discountSum = getSumAfterDiscount(element.sum, element?.productId);
    }

    const categoriesOnDiscounts = amounts.filter(f => discountProducts.findIndex(find => find.products.findIndex(findOne => findOne.id == f.productId) != -1 && find.math == 1) != -1);
    const amountsAllOnDiscounts = +(categoriesOnDiscounts.reduce((a, b) => a + +b.sum, 0));
    const amountsDiscountValue = +(discountProducts.filter(f => f.products.findIndex(findOne => categoriesOnDiscounts.findIndex(find => find.productId == findOne.id) != -1) != -1 && f.math == 1)).reduce((a, b) => a + +b.value, 0);

    onSum(type, sum - amountsAllOnDiscounts + (amountsAllOnDiscounts - amountsDiscountValue));
  }, [amounts, discountProducts]);

  useEffect(() => {
    if (!fileOptions?.products) return;

    const newExtraSlots = {};
    let hasProductsForThisType = false;

    fileOptions.products.forEach(product => {
      if (!product.key) return;
      const catId = parseInt(product.key.split('-')[0]);
      if (!currentCategory.some(cat => cat.id === catId)) return;

      hasProductsForThisType = true;

      const extraMatch = product.key.match(/^(\d+)-x(\d+)$/);
      if (extraMatch) {
        const extraIndex = parseInt(extraMatch[2]);
        newExtraSlots[catId] = Math.max(newExtraSlots[catId] || 0, extraIndex + 1);
      }
    });

    if (hasProductsForThisType) setCollapsed(false);
    if (Object.keys(newExtraSlots).length > 0) setExtraSlots(newExtraSlots);
  }, [fileOptions]);

  const addExtraSlot = (categoryId) => {
    setExtraSlots(prev => ({
      ...prev,
      [categoryId]: (prev[categoryId] || 0) + 1
    }));
  };

  const hasSelectedProduct = (slotKey) => amounts.some(a => a.key === slotKey && a.productId);

  // Build flat slot list preserving global indices (backward compat with saved files keyUnq)
  let globalIdx = 0;
  const allSlots = currentCategory.flatMap(cat => {
    const normalSlots = Array.from({ length: cat.countView }, () => {
      const key = `${cat.id}-${globalIdx++}`;
      return { cat, key };
    });
    const extraCount = extraSlots[cat.id] || 0;
    const extraSlotsList = Array.from({ length: extraCount }, (_, i) => ({
      cat,
      key: `${cat.id}-x${i}`
    }));
    return [...normalSlots, ...extraSlotsList];
  });

  const visibleSlots = collapsed
    ? allSlots.filter(s => hasSelectedProduct(s.key))
    : allSlots;

  const renderSlot = ({ cat, key }) => (
    <ProductCategory
      key={key}
      additionCoefficient={additionCoefficient}
      fileOptions={fileOptions}
      keyUnq={key}
      onSum={(c, s) => setAmounts(updatePropertyInListNoFixed(amounts, 'key', key, 'sum', s))}
      onWeight={(c, s) => setAmounts(updatePropertyInList(amounts, 'key', key, 'weight', s, (s) => onWeight(type, s)))}
      onUpdateProduct={(p) => p
        ? setAmounts([...amounts.filter(f => f.key !== key), { key, sum: 0, weight: 0, productId: p.id }])
        : setAmounts(amounts.filter(f => f.key !== key))
      }
      onUpdate={(p) => onUpdate({ ...p, key })}
      category={cat}
      products={products}
      jwt={jwt}
    />
  );

  return (
    <div className={styles.typeProductCategory}>
      <Stack gap={3} direction="horizontal">
        <Button
          variant="link"
          size="sm"
          onClick={() => setCollapsed(c => !c)}
          style={{ padding: '0 4px', color: 'inherit' }}
        >
          {collapsed ? <FaChevronRight /> : <FaChevronDown />}
        </Button>
        <div className={styles.typeColor} style={{ backgroundColor: type.color }} />
        <OverlayTrigger overlay={<Tooltip id={`type-tooltip-${type.id}`}>{type.description}</Tooltip>}>
          <h4 style={{ marginBottom: 0 }}>{type.name}</h4>
        </OverlayTrigger>
        {!collapsed && currentCategory.length > 0 && (
          <Dropdown>
            <Dropdown.Toggle
              bsPrefix="btn"
              variant="outline-secondary"
              size="sm"
              id={`add-slot-${type.id}`}
            >
              +
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {currentCategory.map(cat => (
                <Dropdown.Item key={cat.id} onClick={() => addExtraSlot(cat.id)}>
                  {cat.name}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </Stack>
      <div className={styles.bodyCategories}>
        {currentCategory && currentCategory.length > 0
          ? visibleSlots.map(slot => renderSlot(slot))
          : <Alert variant="warning">Пусто</Alert>
        }
      </div>
    </div>
  );
}
